import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Mail } from "lucide-react";
import Reveal from "./Reveal";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("You're in.", {
        description: "Soft updates only — appointments, openings, and seasonal notes.",
      });
      setEmail("");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Please try again in a moment.";
      toast.error("Subscription failed", { description: String(msg) });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="newsletter"
      data-testid="newsletter-section"
      className="relative py-24 md:py-32 bg-[#EAD584]"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <Reveal className="overline mb-6">Stay in touch, gently</Reveal>
        <Reveal delay={1}>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-light bb-ink">
            A quiet note in <span className="italic">your inbox.</span>
          </h2>
        </Reveal>
        <Reveal delay={2}>
          <p className="mt-6 bb-ink-soft max-w-xl mx-auto text-base sm:text-lg leading-relaxed font-light">
            Seasonal openings, small skincare rituals, and the occasional
            studio update. Never noisy. Never sold.
          </p>
        </Reveal>
        <Reveal delay={3}>
          <form
            onSubmit={onSubmit}
            data-testid="newsletter-form"
            className="mt-10 max-w-xl mx-auto flex items-center bg-[#FAF6E8] border border-[#D9CFA0] rounded-full pl-5 pr-1 py-1 focus-within:border-[#0F1F4E] transition-colors"
          >
            <Mail className="w-4 h-4 bb-ink-soft" />
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              data-testid="newsletter-email-input"
              aria-label="Email address"
              className="flex-1 bg-transparent border-none outline-none px-4 py-3 text-base bb-ink placeholder:text-[#8a8780] font-light"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="newsletter-submit"
              className="btn-shine inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm tracking-wider uppercase text-[#FAF6E8] bg-[#0F1F4E] hover:bg-[#1B3370] transition-colors disabled:opacity-60"
            >
              {loading ? "Sending…" : "Subscribe"}
              {!loading && <ArrowRight className="w-4 h-4" />}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
